import React from 'react';
import { connect } from 'react-redux';
import SearchBox from './SearchBox';
import PriceInfo from './PriceInfo';
import { fetchIndicatorData, fetchIndicatorPrice } from './reducer';

class IndicatorsSearch extends React.Component {
  componentDidMount() {
    const { fetchIndicatorPrice, indicatorId, currentSearch } = this.props;
    fetchIndicatorPrice(indicatorId, currentSearch.organCode);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      currentSearch,
      fetchIndicatorPrice,
      indicatorId,
      fetchIndicatorData,
    } = this.props;
    if (currentSearch.organCode !== prevProps.currentSearch.organCode) {
      fetchIndicatorPrice(indicatorId, currentSearch.organCode);
      fetchIndicatorData(indicatorId, currentSearch.organCode);
    }
  }

  render() {
    const { code, indicatorId, currentSearch } = this.props;
    return (
      <div className="left-info-widget ml-12">
        <SearchBox
          code={code}
          currentSearch={currentSearch}
          indicatorId={indicatorId}
        />
        <PriceInfo currentSearch={currentSearch} />
      </div>
    );
  }
}

const mapDispatchToProps = {
  fetchIndicatorPrice,
  fetchIndicatorData,
};
export default connect(
  null,
  mapDispatchToProps,
)(IndicatorsSearch);
